<div class="hpanel gs-widget-cardmargin-bottom-5" *ngIf="viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <ul class="profile-list">
          <ng-container *ngFor="let item of user | slice: 0:3; let i = index">
            <app-common-profile-info [type]="'BUSINESS'" [data]="item">
              <ng-container headline1>{{item.businessName}}</ng-container>
              <ng-container headline2>{{item.followerCnt}} Follower(s)</ng-container>
              <ng-container btn><button class="btn-primary btn btn-xs">
                  Follow
                </button>
              </ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
        <!-- <p style="float: right" *ngIf="user.length > 3">
          <u><a >...More</a></u>
        </p> -->

        <button class="gs-743-more-btn" type="button" *ngIf="user.length > 0">
          View more →
        </button>

      </div>
    </div>
  </div>
</div>
<div class="margin-bottom-5"  *ngIf="viewType=='MAX'">
  <div class="panel-body cardw" >
    <div class="row">
      <div class="col-3">
        <div class="col-md-3 padding-left-0 padding-right-5" *ngFor="let item of user">

          <app-business-card [BusinessDataInput]="item"></app-business-card>
        </div>
      </div>
    </div>
  </div>
</div>
